"use strict";

exports.__esModule = true;
exports.Link = void 0;

var React = _interopRequireWildcard(require("react"));

var _styled = require("@manifest-ui/styled");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/link/src/Link.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const LinkRoot = (0, _styled.styled)('a', {
  label: 'Link',
  themeKey: 'link'
})(({
  variant
}) => ({
  alignItems: 'center',
  color: 'primary.500',
  cursor: 'pointer',
  display: 'inline-flex',
  fontFamily: 'body',
  fontWeight: 'medium',
  letterSpacing: 'normal',
  textDecoration: 'none',
  width: 'fitContent',
  '&:hover': {
    backgroundClip: 'text',
    backgroundImage: 'linear-gradient(0deg, rgba(10, 21, 33, 0.2), rgba(10, 21, 33, 0.2))'
  },
  ...(variant === 'link1' && {
    fontSize: 'medium',
    lineHeight: 'large'
  }),
  ...(variant === 'link2' && {
    fontSize: 'small',
    lineHeight: 'medium'
  })
}));
const Link = React.forwardRef((props, ref) => {
  const {
    children,
    variant = 'link1',
    ...other
  } = props;
  return React.createElement(LinkRoot, _extends({
    ref: ref,
    variant: variant
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }), children);
});
exports.Link = Link;
Link.displayName = 'Link';